frappe.provide("erpnext.down_payment");

erpnext.down_payment.set_down_payment_lines = async (frm, company, data) => {
	const reference_dt = frm.doc.doctype === "Sales Invoice" ? "Sales Order" : "Purchase Order";
	const reference_fieldname = frappe.model.scrub(reference_dt);

	const order_id = frm.doc.items.find((line) => line[reference_fieldname])?.[reference_fieldname];
	await frappe.model.with_doc(reference_dt, order_id);
	const order = await frappe.db.get_doc(reference_dt, order_id);

	const use_percentage = flt(data.down_payment_percentage) > 0;
	const down_payment_amount = flt(data.down_payment_amount);

	// Use item_wise_tax_details to group amounts by VAT rate  // @dokos
	const tax_breakdown = (order.item_wise_tax_details || []).reduce((acc, detail) => {
		const rate = detail.rate || 0;
		if (!rate) return acc; // Skip entries with no tax rate (e.g. Actual charges)

		const taxable_amount = detail.taxable_amount || 0;
		const tax_amount = detail.amount || 0;

		if (!acc[rate]) {
			acc[rate] = { taxable_amount: 0.0, tax_amount: 0.0 };
		}

		acc[rate]["taxable_amount"] += taxable_amount;
		acc[rate]["tax_amount"] += tax_amount;

		return acc;
	}, {});

	// Fall back to net_total when item_wise_tax_details cannot be used:
	// - table is empty (no tax details computed)
	// - transaction currency differs from company currency (amounts are in base currency only)
	// - item-level discounts are present (base_total !== base_net_total)
	const use_fallback =
		Object.keys(tax_breakdown).length === 0 ||
		order.currency !== company.default_currency ||
		flt(order.base_total) !== flt(order.base_net_total);

	frm.set_value("items", []);

	if (use_fallback) {
		// Fallback: create a single line on net_total; taxes are preserved so VAT is re-computed
		const d = frm.add_child("items");
		d.qty = 1;
		d.uom = company.default_advance_received_uom;
		d.conversion_factor = 1;
		d.item_name = data.down_payment_label;
		d.item_description = data.down_payment_label;
		d[reference_fieldname] = order_id;

		if (frm.doc.doctype === "Sales Invoice") {
			d.income_account = company.default_advance_received_account;
		} else {
			d.expense_account = company.default_advance_paid_account;
		}

		let dp_amount;
		if (use_percentage) {
			d.down_payment_rate = data.down_payment_percentage;
			dp_amount = (flt(data.down_payment_percentage) / 100.0) * flt(order.net_total);
		} else {
			dp_amount = down_payment_amount;
		}

		d.price_list_rate = dp_amount;
		d.base_net_rate = dp_amount;
		d.base_rate = dp_amount;
		d.rate = dp_amount;
		d.amount = dp_amount;
	} else {
		frm.set_value("taxes", []); // VAT is embedded in each item's gross amount

		const total_taxable = Object.values(tax_breakdown).reduce((sum, v) => sum + v.taxable_amount, 0);

		Object.keys(tax_breakdown).forEach((tax_rate) => {
			const taxable_amount = tax_breakdown[tax_rate]["taxable_amount"];
			const d = frm.add_child("items");
			d.qty = 1;
			d.uom = company.default_advance_received_uom;
			d.conversion_factor = 1;
			d.item_name = data.down_payment_label;
			d.item_description = data.down_payment_label;
			d[reference_fieldname] = order_id;

			if (frm.doc.doctype === "Sales Invoice") {
				d.income_account = company.default_advance_received_account;
			} else {
				d.expense_account = company.default_advance_paid_account;
			}

			let dp_gross;
			if (use_percentage) {
				d.down_payment_rate = data.down_payment_percentage;
				dp_gross = (flt(data.down_payment_percentage) / 100.0) * flt(taxable_amount);
				console.log(data.down_payment_percentage, taxable_amount, tax_rate);
			} else {
				// Distribute the fixed amount proportionally across tax buckets
				dp_gross =
					total_taxable > 0 ? flt(down_payment_amount) * (taxable_amount / total_taxable) : 0;
			}

			d.price_list_rate = dp_gross;
			d.base_net_rate = dp_gross;
			d.base_rate = dp_gross;
			d.rate = dp_gross;
			d.amount = dp_gross;
		});
	}

	frm.refresh_field("items");

	adjust_discount_amount(frm);
};

const adjust_discount_amount = (frm) => {
	if (frm.doc.is_down_payment_invoice) {
		if (frm.doc.additional_discount_percentage === 0.0 && frm.doc.discount_amount > 0.0) {
			frm.set_value("discount_amount", 0.0);
		}
	}
};
